import React from 'react';
import { useParams } from 'react-router-dom';
import i18n from 'i18next';
import Add from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';

import { registerField } from 'core/forms';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import { addTreeItemSelectorModal, InfoBox } from '@/exceed';

import getVideosTopicsTree from '../helpers/getVideosTopicsTree';
import styles from '../styles/formFieldSelectTopic.module.scss';

const FormFieldSelectTopic = ({ model, value, updateField, schema }) => {
  const { orgId } = useParams();
  const { isDisabled } = schema;

  const handleSelectTopic = async ({ item, destination }) => {
    const topic =
      destination.id === 0 ? null : { id: destination.data.topic_id, name: destination.data.name };
    updateField(topic);
  };

  const handleShowSelectTopicModal = ({ item }) => {
    const options = {
      noSearchResultsText: i18n.t('no-results'),
      fetchTree: ({ organizationId = orgId } = {}) => getVideosTopicsTree({ organizationId }),
      treeTopName: i18n.t('topics'),
      searchPlaceholder: i18n.t('search-topics'),
      actionText: i18n.t('select'),
      modalOptions: {
        title: i18n.t('select-topic'),
      },
    };

    addTreeItemSelectorModal({
      item,
      options,
      onActionButtonClick: ({ item, destination }) => handleSelectTopic({ item, destination }),
    });
  };

  return (
    <div className={styles.element}>
      {value ? (
        <InfoBox className={styles.infoBox}>
          <Typo variant="s02" weight="medium" element="span">
            {value.name}
          </Typo>
          <Button
            icon={<Close />}
            iconSize={18}
            variant="ghost"
            size="xsmall"
            onClick={() => updateField(null)}
            isDisabled={isDisabled}
          />
        </InfoBox>
      ) : (
        <Button
          text={i18n.t('add-topic')}
          variant="outlined"
          icon={<Add />}
          onClick={() => handleShowSelectTopicModal({ item: model })}
          isDisabled={isDisabled}
        />
      )}
    </div>
  );
};

registerField('SelectTopic', React.memo(FormFieldSelectTopic));

export default FormFieldSelectTopic;
